import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-cn-pay",
  "use": "icon-soc-cn-pay-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-cn-pay\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"192\" y=\"320\" width=\"640\" height=\"448\" rx=\"40\" /><path d=\"M192 320h640v128H192z\" /><circle cx=\"736\" cy=\"544\" r=\"48\" fill=\"#fff\" /><circle cx=\"736\" cy=\"288\" r=\"48\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-cn-pay.svg
// module id = 6xZ4
// module chunks = 477